<template>
  <v-layout row>
    <v-flex
      md8
    >
      <v-container class="pb-1">
        <v-layout
          row
        >
          <v-flex md4>
            <v-text-field
              v-model.trim="serialNo"
              label="シリアルNo"
            />
          </v-flex>
          <v-flex md3>
            <v-select
              v-model="assigned"
              :items="assignStatus"
              label="割当"
            />
          </v-flex>
          <v-flex md3>
            <v-select
              v-model="installed"
              :items="installStatus"
              label="取付"
            />
          </v-flex>
          <v-flex
            md2
          >
            <v-btn
              color="success"
              @click="search"
            >
              検索
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  data () {
    return {
      assignStatus: [
        { text: 'すべて', value: -1 },
        { text: '未割当', value: 0 },
        { text: '割当済み', value: +1 }
      ],
      installStatus: [
        { text: 'すべて', value: -1 },
        { text: '未取付', value: 0 },
        { text: '取付済み', value: +1 }
      ],
      action: 0,
      serialNo: '',
      assigned: -1,
      installed: -1
    }
  },
  methods: {
    init (cond) {
      const fit = v => {
        if (v == null) return -1

        const n = parseInt(v, 10)
        if (isNaN(n)) return -1
        return n
      }

      this.serialNo = cond.serialNo
      this.assigned = fit(cond.assigned)
      this.installed = fit(cond.installed)
    },
    search () {
      this.$emit('search', {
        serialNo: this.serialNo,
        assigned: this.assigned,
        installed: this.installed
      })
    }
  }
}
</script>
